import React from 'react'

import CompetitiveIntelligenceHeader from 'components/CompetitiveIntelligence/Header'
import CompetitorQuickFilters from 'components/CompetitiveIntelligence/CompetitorQuickFilters'
import MetricSummary from 'components/CompetitiveIntelligence/MetricSummary'
import ResearchFilters from 'components/CompetitiveIntelligence/ResearchFilters'
import ResearchList from 'components/CompetitiveIntelligence/ResearchList'
import ResearchListSkeleton from 'components/CompetitiveIntelligence/ResearchListSkeleton'
import CompetitiveIntelligenceState from 'components/CompetitiveIntelligence/State'
import useController from './controller'
import { Page } from './styled'

const STATE_COPY = {
    denied: ['competitive_intelligence_denied_title', 'competitive_intelligence_denied_description'],
    emptyCorpus: ['competitive_intelligence_research_empty_corpus_title', 'competitive_intelligence_research_empty_corpus_description'],
    emptySearch: ['competitive_intelligence_research_empty_search_title', 'competitive_intelligence_research_empty_search_description'],
    emptyFilter: ['competitive_intelligence_research_empty_filter_title', 'competitive_intelligence_research_empty_filter_description'],
    error: ['competitive_intelligence_research_error_title', 'competitive_intelligence_research_error_description'],
    unavailable: ['competitive_intelligence_unavailable_title', 'competitive_intelligence_unavailable_description'],
}

export default function CompetitiveIntelligenceResearch() {
    const controller = useController()
    return (
        <Page>
            <CompetitiveIntelligenceHeader
                description={controller.t('competitive_intelligence_research_description')}
                eyebrow={controller.t('competitive_intelligence_title')}
                t={controller.t}
                title={controller.t('competitive_intelligence_nav_research')}
            />
            {controller.status === 'loading' ? (
                <ResearchListSkeleton label={controller.t('competitive_intelligence_research_loading')} />
            ) : ['ready', 'emptySearch', 'emptyFilter', 'emptyCorpus'].includes(controller.status) ? (
                <>
                    <MetricSummary
                        facets={controller.facets || { sources: [] }}
                        formatCount={controller.formatCount}
                        total={controller.corpusTotal ?? controller.pagination.total}
                        t={controller.t}
                    />
                    <ResearchFilters {...controller} />
                    <CompetitorQuickFilters
                        competitors={controller.facets?.competitors || []}
                        filters={controller.filters}
                        formatCount={controller.formatCount}
                        onFilterChange={controller.onFilterChange}
                        t={controller.t}
                    />
                    {controller.status === 'ready' ? (
                        <ResearchList {...controller} />
                    ) : (
                        <CompetitiveIntelligenceState
                            actionLabel={controller.t('competitive_intelligence_research_clear_filters')}
                            description={controller.t(STATE_COPY[controller.status][1])}
                            onAction={controller.status === 'emptyCorpus' ? undefined : controller.onReset}
                            title={controller.t(STATE_COPY[controller.status][0])}
                        />
                    )}
                </>
            ) : STATE_COPY[controller.status] ? (
                <CompetitiveIntelligenceState
                    actionLabel={controller.t('try_again')}
                    description={controller.t(STATE_COPY[controller.status][1])}
                    onAction={['error', 'unavailable'].includes(controller.status) ? controller.retry : undefined}
                    title={controller.t(STATE_COPY[controller.status][0])}
                    urgent
                />
            ) : null}
        </Page>
    )
}
